
const checkContractStatus = (status: string) => {
  switch (status) {
  case 'approved':
    return 'active'
    break
  case 'pending':
    return 'pending'
    break
  case 'denied':
    return 'inactive'
    break
  default:
    return 'inactive'
  }
}

export default checkContractStatus
